import { Button, Col, Row, Input, DatePicker } from "antd";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import SelectStatus from "../../../components/SelectStatus";
import dayjs from "dayjs";
import { usePermissions } from "../../../utils/permissionUtil";
import UserManualButton from "../../../components/UserManualButton";
import SelectClient from "../../../components/SelectClient";
const { Search } = Input;

const FilterMenu = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { hasCreatePermission } = usePermissions();

  const onSearch = (value) => {
    updateSearchParam("name", value);
  };

  const onClear = (value) => {
    updateSearchParam("name", null);
  };

  const handleNavigate = () => {
    navigate(`/inbound/add`);
  };

  const updateSearchParam = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (value !== null) {
      newSearchParams.set(key, value);
    } else {
      newSearchParams.delete(key);
    }
    setSearchParams(newSearchParams);
  };

  return (
    <Row
      align="top"
      style={{ marginBottom: "18px" }}
      justify={"space-between"}
      gutter={[8, 8]}
    >
      <Col lg={16} xs={24}>
        <Row gutter={[8, 8]} align={"middle"}>
          <Col lg={6} md={6} sm={12} xs={24}>
            <>
              <p style={{ marginBottom: 4, padding: 2 }}>Tanggal Request</p>
              <DatePicker
                style={{ width: "100%" }}
                format="YYYY-MM-DD"
                placeholder="Pilih Tanggal"
                onChange={(e) =>
                  updateSearchParam(
                    "request_date",
                    e ? dayjs(e).format("YYYY-MM-DD") : null,
                  )
                }
              />
            </>
          </Col>
          <Col lg={4} md={4} sm={12} xs={24}>
            <>
              <p style={{ marginBottom: 4, padding: 2 }}>Tanggal Masuk</p>
              <DatePicker
                style={{ width: "100%" }}
                format="YYYY-MM-DD"
                placeholder="Pilih Tanggal"
                onChange={(e) =>
                  updateSearchParam(
                    "data_in",
                    e ? dayjs(e).format("YYYY-MM-DD") : null,
                  )
                }
              />
            </>
          </Col>
          <Col lg={4} md={4} sm={12} xs={24}>
            <>
              <p style={{ marginBottom: 4, padding: 2 }}>Status</p>
              <SelectStatus
                value={searchParams.get("status") || null}
                onChange={(e) => updateSearchParam("status", e || null)}
              />
            </>
          </Col>
          <Col lg={4} md={4} sm={12} xs={24}>
            <>
              <p style={{ marginBottom: 4, padding: 2 }}>Pemilik</p>
              <SelectClient
                value={+searchParams.get("client_id") || null}
                onChange={(e) => updateSearchParam("client_id", e || null)}
              />
            </>
          </Col>
          <Col lg={3} md={4} sm={5} xs={24}>
            <p style={{ marginBottom: 4, padding: 2, color: "#FFF" }}>
              Clear Filter
            </p>
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <Button
                style={{ width: "100%" }}
                onClick={() => {
                  setSearchParams({});
                }}
              >
                Clear Filter
              </Button>
              <UserManualButton />
            </div>
          </Col>
        </Row>
      </Col>
      <Col lg={8} xs={24}>
        <Row gutter={[8, 8]} align={"middle"} justify={"end"}>
          <Col xl={12} lg={14} md={6} sm={8} xs={24}>
            <>
              <p style={{ marginBottom: 4, padding: 2, color: "#FFF" }}>
                Search
              </p>
              <Search
                placeholder="Input Jenis Produk"
                allowClear
                defaultValue={searchParams.get("search") || null}
                onSearch={onSearch}
                style={{ width: "100%" }}
                onClear={onClear}
              />
            </>
          </Col>
          {hasCreatePermission("Inbound") && (
            <Col xl={8} lg={8} md={4} sm={6} xs={24}>
              <>
                <p style={{ marginBottom: 4, padding: 2, color: "#FFF" }}>
                  New Inbound
                </p>
                <Button
                  style={{ width: "100%" }}
                  type="primary"
                  onClick={() => handleNavigate()}
                >
                  New Inbound
                </Button>
              </>
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default FilterMenu;
